orders-planner-schedules
  orders-planner-schedules-cell(each="{id in opts.schedules}" tag-scope="schedule_{id}")
  script(type="typescript").
    this.mixin('orders.planner.schedules');
